import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import ScrollShot from '../../components/ui/ScrollShot';

const PRODUCTS = [
  {
    name: 'BluBeds',
    status: 'Live',
    line: 'Our travel tech platform for hotel bookings, event stays and business travel. Built by Bluprise, from the booking experience to the integrations behind it.',
    media: 'blubeds/blubeds',
    to: '/work/blubeds',
    href: 'https://blubeds.com',
  },
  {
    name: 'Nighthouse',
    status: 'Live',
    line: 'Nightlife map, live rooms and tables for Cairo and Dubai. Every Bluprise client gets Plus: a private room for our meetings, no Zoom.',
    media: 'nighthouse/nighthouse-home',
    to: '/work/nighthouse',
    href: 'https://nighthouse.app',
  },
  {
    name: 'ValidMy.email',
    status: 'Live',
    line: 'Email verification with real SMTP handshakes, disposable detection and a bulk API. It is why every mail we send for you is verified first.',
    media: 'validmyemail/validmyemail-home',
    to: '/work/validmyemail',
    href: 'https://validmy.email',
  },
  {
    name: 'Postify',
    status: 'Early access',
    line: 'Brief a campaign, approve the drafts, and let it post to Meta, YouTube, TikTok, X and LinkedIn from one calendar.',
    media: 'postify/postify-home',
    href: 'https://postify.social',
  },
  {
    name: 'FillAI',
    status: 'Waitlist',
    line: 'A browser agent that fills forms, works portals and finishes the repetitive desktop work your team hates.',
    media: 'fillai/fillai-home',
    href: 'https://fillai.postify.social',
  },
];

// Own products: editorial list, not a card grid. Two carry screenshots,
// two are text-first because they are pre-launch.
export default function OwnProducts() {
  return (
    <section className="border-t border-line py-16 md:py-24">
      <div className="container-x">
        <div className="max-w-3xl">
          <h2 className="reveal display-lg">We ship our own products. That is the point.</h2>
          <p className="reveal lede mt-6" data-delay="80">
            Our own products, including BluBeds, keep us close to the work, and come with perks for clients: every email
            you send through us is verified by ValidMy.email, and every meeting gets a private Nighthouse room.
          </p>
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {PRODUCTS.map((p) => (
            <article key={p.name} className="reveal flex flex-col justify-between rounded-2xl border border-line bg-deep p-6 md:p-8">
              <div>
                <div className="flex items-center justify-between">
                  <h3 className="font-display text-3xl font-normal tracking-tight">{p.name}</h3>
                  <span className={'rounded-full px-3 py-1 text-xs ' + (p.status === 'Live' ? 'bg-cobalt/20 text-sky' : 'border border-line text-mist')}>{p.status}</span>
                </div>
                <p className="mt-4 max-w-prose text-mist">{p.line}</p>
              </div>
              {p.media ? (
                <div className="group mt-8 overflow-hidden rounded-xl border border-line"><ScrollShot mediaKey={p.media} alt={p.name} className="aspect-[16/10]" /></div>
              ) : (
                <div className="mt-8 rounded-xl bg-cobalt/10 p-6 text-sm text-sky">Opening soon. Join from the client hub.</div>
              )}
              <div className="mt-6 flex items-center gap-5 text-sm">
                {p.to ? <Link to={p.to} className="inline-flex items-center gap-1 text-cream hover:text-sky">Case study <ArrowUpRight className="h-4 w-4" /></Link> : null}
                <a href={p.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-mist hover:text-cream">Visit <ArrowUpRight className="h-4 w-4" /></a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
